<div class="cv-tb">

  <!-- Select / escape-drawing tool (always first) -->
  <lib-canvas-select-tool [active]="selectActive" (select)="selectTool.emit()"></lib-canvas-select-tool>

  <lib-canvas-search-tool (search)="search.emit($event)"></lib-canvas-search-tool>

  <lib-canvas-draw-circle-tool [active]="addPointActive" (draw)="addPoint.emit()"></lib-canvas-draw-circle-tool>
  <lib-canvas-draw-polygon-tool (draw)="drawShape.emit($event)"></lib-canvas-draw-polygon-tool>
  <lib-canvas-measure-tool
    [active]="measureActive"
    (measure)="measure.emit()"
  ></lib-canvas-measure-tool>

  <lib-canvas-basemap-tool
    [activeBasemap]="activeBasemap"
    [basemaps]="basemaps"
    (basemapChange)="basemapChange.emit($event)"
  ></lib-canvas-basemap-tool>
  <lib-canvas-swipe-tool [active]="swipeActive" (swipe)="swipe.emit()"></lib-canvas-swipe-tool>

  <lib-canvas-export-tool
    [map]="map"
    [userDrawSource]="userDrawSource"
    [exportLayers]="exportLayers"
  ></lib-canvas-export-tool>
  <lib-canvas-import-tool
    [map]="map"
    [userDrawSource]="userDrawSource"
    [hasExistingLayers]="hasExistingLayers"
    (featuresImported)="featuresImported.emit($event)"
  ></lib-canvas-import-tool>

</div>
